export const LINKED_TRANSACTION_FIELDS = {
  CONNECTOR_NAME: {
    label: 'Connector',
    field: 'connector_name',
  },
  ACCOUNT_NAME: {
    label: 'Account name',
    field: 'account_name',
  },
  ACCOUNT_NUMBER: {
    label: 'Account number',
    field: 'account_number',
  },
  ACCOUNT_TYPE: {
    label: 'Account type',
    field: 'account_type',
  },
  TAGS: {
    label: 'Tags',
    field: 'tags',
  },
  YEAR: {
    label: 'Year',
    field: 'year',
  },
  QUARTER: {
    label: 'Quarter',
    field: 'quarter',
  },
  MONTH: {
    label: 'Month',
    field: 'month',
  },
  DATE: {
    label: 'Date',
    field: 'date',
  },
  TYPE: {
    label: 'Transaction type',
    field: 'type',
  },
  ACCESS_METHOD: {
    label: 'Access method',
    field: 'access_method',
  },
  CATEGORY: {
    label: 'Category',
    field: 'category',
  },
  SUBCATEGORY: {
    label: 'Subcategory',
    field: 'subcategory',
  },
  COUNTERPARTY: {
    label: 'Counterparty',
    field: 'counterparty',
  },
  DESCRIPTION: {
    label: 'Description',
    field: 'description',
  },
  AMOUNT: {
    label: 'Amount',
    field: 'amount',
  },
  STATUS: {
    label: 'Status',
    field: 'status',
  },
}

export const LINKED_TRANSACTIONS_SEARCH_KEY = [
  'linked-data',
  'transactions',
  'search',
]
export const LINKED_TRANSACTIONS_FILTER_KEY = [
  'linked-data',
  'transactions',
  'filter',
]
export const LINKED_TRANSACTIONS_SORT_KEY = [
  'linked-data',
  'transactions',
  'sort',
]
export const LINKED_TRANSACTIONS_PAGE_SIZE_KEY = [
  'linked-data',
  'transactions',
  'pageSize',
]

export const LINKED_DATA_POSITIONS_SEARCH_KEY = [
  'linked-data',
  'positions',
  'search',
]

export const LINKED_DATA_POSITIONS_FILTER_KEY = [
  'linked-data',
  'positions',
  'filter',
]

export const LINKED_DATA_POSITIONS_SORT_KEY = [
  'linked-data',
  'positions',
  'sort',
]

export const ACCOUNT_TAG_PREFIX = 'account_tag:'
